/// <reference path="../../../types.d.ts" />
import { connect } from 'react-redux';
import { buildDispatchable } from '../../../actions/_action-utilities';
import externalAppActions from '../../../actions/external-applications';
import history from '../../../history';
import { ExternalAppUserForm } from './external-app-user-form';
const mapStateToProps = function(state) {
    const { externalApplications } = state;
    return {
        selectedUser: externalApplications.selectedUser,
        errors: externalApplications.userFormErrors
    };
};
const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        handleSave: (user)=>{
            runDispatchable(()=>{
                return dispatch(externalAppActions.saveExternalAppUser(user));
            });
        },
        handleCancel: ()=>{
            runDispatchable(()=>{
                history.goBack();
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ExternalAppUserForm);
